"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Returns an empty Slate editor document.
 */
function createEmptyDocument() {
    return [{ children: [{ text: '' }], type: 'paragraph' }];
}
exports.default = createEmptyDocument;
//# sourceMappingURL=createEmptyDocument.js.map